import {
    FaCity,
    FaPhone,
    FaMapMarkerAlt,
  } from "react-icons/fa";
  
  export default function CenterCard({ center, isOpen, toggleCenter, isArabic }) {
    return (
      <div
        className="bg-white shadow-md rounded-xl p-4 transition duration-300 hover:shadow-xl cursor-pointer"
        onClick={() => toggleCenter(center.id)}
        dir={isArabic ? "rtl" : "ltr"}
      >
        <div className="text-center mb-3">
          <h2 className="text-lg font-bold text-primary-blue">{center.name}</h2>
        </div>
  
        <div className="text-sm text-gray-700 mb-2 flex items-center gap-2">
          <FaCity className="text-gray-500" /> {center.city}
        </div>
  
        <div className="text-sm text-gray-700 mb-2 flex items-center gap-2">
          <FaPhone className="text-gray-500" /> {center.phoneNumber}
        </div>

  
        {isOpen && (
          <div className="text-sm text-gray-600 mt-2">
            <p className="flex items-center gap-2">
              <FaMapMarkerAlt className="text-red-500" />
              {center.address}
            </p>
            <p className="mt-2">{center.description}</p>
          </div>
        )}
  
        {!isOpen && (
          <p className="text-gray-500 mt-2 text-sm">
            {center.description.slice(0, 50)}...
          </p>
        )}
      </div>
    );
  }
  